// extracted by mini-css-extract-plugin
export default {"contactList":"ContactList_contactList__UFVCg"};